import React, { FC, useCallback, useMemo } from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Form } from '@ant-design/compatible';
import OWAsyncRadio from '../visual_radio_input/VisualRadioInput';
import { connect } from 'react-redux';
import { areasRestCrudThunksForBuyer, areasTopLevelForBuyer } from '../../thunks/areas_thunks';
import { Button } from 'antd';
import {
	AREA_LEVELS,
	AREA_STEP_PROPS,
	getAreaStepStateVariables,
	handleAreaChange,
} from './wo_creation_area_utils';

const TC_NAME = 'WORK_ORDER_FORM_AREAS_TOP_LEVEL_AUTOCOMPLETE';

const WOArea: FC<any> = ({
	getCurrentState,
	goBack,
	form,
	goNext,
	setState,
	changeId,
	fieldName,
	isProcessing,

	areas,
	fetchMultipleAreas,
	fetchAreasTopLevel,
	fetchAreas,
	fetchArea,
}): React.ReactElement => {
	const { getFieldDecorator } = form;

	const areaProps: AREA_STEP_PROPS = useMemo(
		() => ({
			goNext,
			setState,
			getCurrentState,
			areas,
			TC_NAME,
			fetchArea,
			changeId,
		}),
		[areas, changeId, fetchArea, getCurrentState, goNext, setState]
	);

	const state = useMemo(() => getCurrentState(), [getCurrentState]);

	const onAreaChange = useCallback(
		(id) => handleAreaChange(areaProps)(fieldName, id),
		[areaProps, fieldName]
	);

	const stateVariables = getAreaStepStateVariables(fieldName);

	const isTopLevel = useMemo(() => fieldName === AREA_LEVELS.TOP_LEVEL, [fieldName]);

	return (
		<div key={2} className="newWorkOrderWizardPage__section">
			<h3 className="newWorkOrderWizardPage__title">Which area is the request for?</h3>
			<Form.Item style={{ width: '100%' }}>
				{getFieldDecorator(fieldName, {
					rules: [
						{
							required: false,
						},
					],
					initialValue: nullSafeGet(stateVariables.currentLevelId, state),
				})(
					<OWAsyncRadio
						getDescription={(record) => record.description}
						autoPickFirstOption
						mode="default"
						fieldName={fieldName}
						stateSlice={areas}
						additionalFilters={{
							locationId: nullSafeGet('location.id', state),
							brandId: nullSafeGet('location.brandId', state),
						}}
						onChange={onAreaChange}
						onClick={onAreaChange}
						targetCollectionName={TC_NAME}
						fetchMultiple={(ids, targetCollectionName) =>
							fetchMultipleAreas(ids, targetCollectionName)
						}
						fetchData={(
							searchText,
							targetCollectionName,
							pagination = null,
							sorting = null,
							filters = null
						) => {
							const fnToCall = isTopLevel ? fetchAreasTopLevel : fetchAreas;
							return fnToCall(
								{
									name: searchText,
									...(isTopLevel
										? {}
										: {
												...(stateVariables.prevLevelId && {
													parentId: nullSafeGet(stateVariables.prevLevelId, state),
												}),
										  }),
								},
								targetCollectionName,
								pagination,
								sorting,
								filters
							);
						}}
						renderRecord={(area) => area.name}
					/>
				)}
			</Form.Item>
			<Button
				size="large"
				type="ghost"
				onClick={goBack}
				loading={isProcessing}
				disabled={isProcessing}
			>
				Back
			</Button>
		</div>
	);
};

const mapStateToProps = (state) => ({
	areas: state.areas,
});

const mapDispatchToProps = (dispatch) => ({
	fetchAreasTopLevel: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			areasTopLevelForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAreas: (ids, targetCollectionName) =>
		dispatch(areasRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			areasRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchArea: (id) => dispatch(areasRestCrudThunksForBuyer.readOne(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WOArea);
